import { Iconify } from "@repo/design-system/components/ui";
import PropTypes from 'prop-types';
import "./NoRecordFound.scss";
import { notFound } from '@gyandiksha/shared-ui/assets';

export const NoRecordFound = ({
  message = "No Record Found",
  isEnabledIcon = true,
  icon = "lucide:alert-triangle",
  isEnabledImage = false,
  imageURL = notFound,
  className = ""
}) => {
  return (
    <div className={`record-not-found ${className}`}>
      {imageURL && isEnabledImage &&
        <img className="not-found-img" src={imageURL} alt="Not Found" />
      }
      {icon && isEnabledIcon && !isEnabledImage &&
        <Iconify icon={icon} />
      }
      <h5 className={`not-found-message ${isEnabledIcon && "icon-not-found-message"}`}>{message}</h5>
    </div>
  );
}

NoRecordFound.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.string,
  imageURL: PropTypes.string,
  className: PropTypes.string,
  isEnabledIcon: PropTypes.bool,
  isEnabledImage: PropTypes.bool,
};

